import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AgenciaService } from "../../servicios/agencia.service";
import { Utils } from "../../utils/utils";
import { UsuarioService } from "../../servicios/usuario.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import * as _moment from "moment";

import { DataTableDirective } from "angular-datatables";
import { DialogDetallePedidoComponent } from "../../dialogs/dialog-detalle-pedido/dialog-detalle-pedido.component";

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { startWith, map } from "rxjs/operators";
import { GestionVendedorService } from "../../servicios/gestion-vendedor.service";

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD",
  },
};

export interface Usuario {
  id: string;
  valor: string;
}

@Component({
  selector: "app-informe-ordenes-pedido",
  templateUrl: "./informe-ordenes-pedido.component.html",
  styleUrls: ["./informe-ordenes-pedido.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InformeOrdenesPedidoComponent implements OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  ventasGroup: FormGroup;
  loadingAgencias = false;
  loadingUsuarios = false;
  loading = false;
  usuarioConsulta = "";
  filteredUsuarios: Observable<Usuario[]>;
  agencias = [];
  usuarios = [];
  dataVentas = [];
  haveData = false;
  timeRunning = 0;
  alternate: boolean = false;
  isExpanded: boolean = false;
  mostrarIcono: boolean = true;

  dtTrigger = new Subject();

  constructor(
    private fb: FormBuilder,
    private servicioAgencia: AgenciaService,
    private serviceUsuario: UsuarioService,
    private servicioGestionVendedor: GestionVendedorService,
    public ruta: Utils,
    private dialog: MatDialog
  ) {
    this.ventasGroup = this.fb.group({
      idAgencia: ["", Validators.required],
      usuarioCtrl: ["", Validators.required],
      fechaInicial: [new Date(), Validators.required],
      fechaFinal: [new Date(), Validators.required],
    });

    const fechaHoy = new Date();
    const nFecha = _moment(fechaHoy, "YYYY-MM-DD").format("YYYY-MM-DD");
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.loadingAgencias = true;
    this.servicioAgencia
      .getAgencia(infoUsuario[0].IdUsuario, 0)
      .subscribe((result) => {
        this.agencias = result;
        this.agencias.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.ventasGroup.controls["idAgencia"].setValue("0");
        this.loadingAgencias = false;
        this.ventasGroup.get("idAgencia").valueChanges.subscribe((value) => {
          this.cargarUsuariosAgencia();
        });
        //console.log(this.agencias);
      });

    this.loadingUsuarios = true;
    this.serviceUsuario
      .getUsuariosPersonas(3, infoUsuario[0].IdUsuario, 0, 0) //3 para tipo usuario vendedor
      .subscribe((result) => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.ventasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS",
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.ventasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map((usuario) =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });

    this.cargarInformacion(0, 0, nFecha, nFecha, this.usuarioConsulta);
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  private _filterUsuarios(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.usuarios.filter(
      (usuario) => usuario.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  cargarUsuariosAgencia() {
    this.loadingUsuarios = true;
    const agencia = this.ventasGroup.get("idAgencia").value;

    this.serviceUsuario
      .getUsuariosPersonas(3, this.usuarioConsulta, agencia, 0) //3 es para usuarios tipo vendedor
      .subscribe((result) => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.ventasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS",
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.ventasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map((usuario) =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });
  }

  displayFn(usuario) {
    //console.log(JSON.stringify(usuario));
    return usuario ? usuario.valor : usuario;
  }

  cargarInformacion(
    usuario,
    agencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta
  ) {
    this.loading = true;
    this.servicioGestionVendedor
      .getGestionVendedor(
        usuario,
        agencia,
        fechaInicial,
        fechaFinal,
        idUsuarioConsulta,
        0
      )
      .subscribe((data) => {
        this.dataVentas = data;
        this.loading = false;
        if (data.length > 0) {
          this.haveData = true;
        }

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;
      });
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  busqueda() {
    //console.log( this.ventasGroup.get('usuarioCtrl').value);
    //console.log(this.entregasGroup.get('idAgencia').value);
    //return;
    const usuarioConsulta = this.usuarioConsulta;
    const agencia = this.ventasGroup.get("idAgencia").value;
    const usuario = this.ventasGroup.get("usuarioCtrl").value;
    const fechaInicial = _moment(
      this.ventasGroup.get("fechaInicial").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    const fechaFinal = _moment(
      this.ventasGroup.get("fechaFinal").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    //const tipoConsulta = this.ventasGroup.get('tipoConsulta').value;
    //console.log(tipoConsulta);
    //return;
    this.cargarInformacion(
      usuario.id,
      agencia,
      fechaInicial,
      fechaFinal,
      usuarioConsulta
    );
  }

  verDetalle(item) {
    console.log(item);
    const dialogRef = this.dialog.open(DialogDetallePedidoComponent, {
      data: item,
      width: "100em",
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      /*if (result) {
        this.refrescaBusqueda();
      }*/
      console.log("Resultado es :" + result);
    });
  }
}
